import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import AddCircle from '@mui/icons-material/AddCircle';
import {
  CardHeader,
  Divider,
  List,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import React from 'react';
import STRING_KEYS from '../../../../language/keys';
import { Anchor } from '../../../../components/Anchor';
import { VIEW_MODE } from '../../../../consts/enums';
import { TalentSocialLinkItem } from './TalentSocialLinkItem';
import { style } from './TalentSocialLink.style';

type TalentSocialLinksProps = {
  socialLinks: SocialLinkItem[],
  removeSocialLinkHandler?: (itemId: string) => void,
  editSocialLinkHandler?: (updatedItem: SocialLinkItem) => void,
  addSocialLinkHandler?: ()=> void,
  formErrors?: ErrorsValidatationDefauls,
  disabled?: boolean,
  viewMode : ViewMode
}

const TalentSocialLinks = ({
  socialLinks,
  removeSocialLinkHandler,
  editSocialLinkHandler,
  addSocialLinkHandler,
  formErrors = {},
  disabled = false,
  viewMode,
}:TalentSocialLinksProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const checkIfError = (item: SocialLinkItem) => {
    if (formErrors?.socialLinks) {
      return formErrors.socialLinks
        .find((socialLoginError) => item.id === socialLoginError.id) || null;
    }

    return null;
  };

  const canAddNew = typeof addSocialLinkHandler === 'function' && viewMode === VIEW_MODE.EDITABLE;

  const cardStyle = {
    ...style.cardStyle,
    ...(disabled) && style.cardDisabled,
  };

  return (
    <Card sx={ { minWidth: 275 } } style={ cardStyle }>
      <Anchor id="social-links" />
      <CardHeader
        title="Social Links"
        style={ {
          padding: '24px 24px',
        } }
      />
      <CardContent style={ { padding: 0 } }>
        <List style={ style.listViewMode }>
          <Divider />
          {socialLinks.map((item) => {
            return (
              <TalentSocialLinkItem
                key={ item.id }
                itemId={ item.id }
                socialType={ item.socialType }
                url={ item.url }
                removeSocialLinkHandler={ removeSocialLinkHandler }
                editSocialLinkHandler={ editSocialLinkHandler }
                error={ checkIfError(item) }
                disabled={ disabled }
                viewMode={ viewMode }
              />
            );
          })}
        </List>
      </CardContent>

      {/* todo: text from language file */}

      {canAddNew && (
        <CardActions>
          <Button
            size="large"
            startIcon={ <AddCircle color="primary" /> }
            onClick={ addSocialLinkHandler }
          >{translate(STRING_KEYS.ADD_NEW_SOCIAL_LINK)}
          </Button>
        </CardActions>
      )}
    </Card>
  );
};

TalentSocialLinks.defaultProps = {
  removeSocialLinkHandler: undefined,
  editSocialLinkHandler: undefined,
  addSocialLinkHandler: undefined,
  formErrors: {},
  disabled: false,
};

export default React.memo(TalentSocialLinks);
